import { render, staticRenderFns } from "./CreateSubstance.vue?vue&type=template&id=4e9cad5c&scoped=true&"
import script from "./CreateSubstance.vue?vue&type=script&lang=js&"
export * from "./CreateSubstance.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubstance.vue?vue&type=style&index=0&id=4e9cad5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9cad5c",
  null
  
)

export default component.exports